import * as go from 'gojs';
import { getImageGenericScreen } from 'unitData/Generic/GenericScreen/getImageGenericScreen';
import {
  getImageBinding,
  getIOPort,
  getDeckPortPanel,
  makeNode,
} from '../../utils';

const alignScreenPort = (
  mirrored: boolean,
  portIndex: number,
  nbrOfDecks?: number,
) => {
  const x = mirrored ? 0 : 1;
  const nbrTicks = 6;
  const offset = 0;

  if (nbrOfDecks === undefined) {
    return go.Spot.Center;
  }

  if (nbrOfDecks === portIndex) {
    return new go.Spot(0.5, 1);
  }

  return new go.Spot(
    x,
    (nbrTicks - (nbrOfDecks - portIndex) - offset) / nbrTicks,
  );
};

const GenericScreenTemplate = makeNode(
  getImageBinding('', getImageGenericScreen),
  [
    getIOPort(go.Spot.Top, 'input'),
    getDeckPortPanel(0, alignScreenPort),
    getDeckPortPanel(1, alignScreenPort, (node) => node.nbrOfDecks >= 1),
    getDeckPortPanel(2, alignScreenPort, (node) => node.nbrOfDecks >= 2),
    getDeckPortPanel(3, alignScreenPort, (node) => node.nbrOfDecks >= 3),
    getDeckPortPanel(4, alignScreenPort, (node) => node.nbrOfDecks >= 4),
  ],
);

export default GenericScreenTemplate;
